export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en", {
    maximumFractionDigits: 0
  }).format(value);
}

export function formatPercent(numerator: number, denominator: number): string {
  if (!denominator) return "0%";
  return `${Math.round((numerator / denominator) * 100)}%`;
}

export function formatShortDate(day: string): string {
  const date = new Date(`${day}T00:00:00`);
  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric"
  }).format(date);
}
